<template>
  <div class="describe">
    <img class="describe-icon" :src="iconUrl">
    <div class="describe-center">
      <div class="describe-center-title">{{ title }}</div>
      <div class="describe-center-type" @click="openOfficial">{{ type }}</div>
      <div class="describe-center-brief">{{ brief }}</div>
    </div>
    <div class="describe-score" v-if="score!=='hide'">
      <span>{{ score }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Describe',
  props: {
    score: {
      type: String,
      default: '暂无'
    },
    iconUrl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    brief: {
      type: String,
      default: ''
    }
  },
  methods: {
    openOfficial () {
      this.$parent.openOfficial()
    }
  }
}
</script>

<style scoped lang="scss">
.describe{
  position: relative;
  padding: 17px 0;
  display: flex;
  align-items: center;
  .describe-icon{
    width: 79px;
    height: 79px;
    background: #959595;
    border-radius: 15px;
  }
  .describe-center{
    margin-left: 14px;
    .describe-center-title{
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #F5F5F5;
      margin-bottom: 6px;
    }
    .describe-center-type{
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #2992FF;
      margin-bottom: 6px;
    }
    .describe-center-brief{
      font-size: 13px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #68829E;
      width: 242px;
      overflow: hidden;
      text-overflow:ellipsis;
      white-space: nowrap;
    }
  }
  .describe-score{
    width: 43px;
    height: 58px;
    background: url("../../../public/image/Instrument/pingfeng.png");
    background-size: 100% 100%;
    position: absolute;
    right: 10px;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 800;
    color: #2992FF;
    display: flex;
    justify-content: center;
    align-items: center;
    >span{
      margin-bottom: 10px;
    }
  }

}
</style>
